<template>
	<BaseCmsPage v-slot="{page}">
		<Body :class="['cart-layout-page']" />
		<ClientOnly>
			<BaseWebshopCart v-slot="{counter, parcels, urls, cart, onFinishShopping}" :remarketing="true">
				<CmsIntroContainer :page="page" mode="cart">
					<template #h1>
						<h1 class="w-title" v-if="page?.seo_h1">{{ page.seo_h1 }}<span class="w-counter active" v-if="counter">(<span>{{counter}}</span>)</span></h1>
					</template>
				</CmsIntroContainer>
				
				<BaseWebshopFreeShipping v-slot="{item: toFree}">
					<div class="cart-layout" v-if="parcels?.length">
						<div class="wider-wrapper">
							<template v-if="parcels[0]?.items?.length">
								<div class="clear" id="view_cart">
									<div class="w-cols">
										<div class="w-col1">
											<BaseWebshopCartErrors v-slot="{errorsItems, warningsItems}">
												<template v-if="errorsItems?.length">
													<div class="global-error" v-for="error in errorsItems" :key="error"><BaseCmsLabel :code="error.label_name" /></div>
												</template>
												<template v-if="warningsItems?.length">
													<div class="global-warning" v-for="warning in warningsItems" :key="warning"><BaseCmsLabel :code="warning.label_name" /></div>
												</template>
											</BaseWebshopCartErrors>

											<template v-if="cart?.indicators?.cart_link?.items?.length && cart?.indicators?.cart_link?.datetime_expires && cart?.indicators?.cart_link?.datetime_expires > Math.floor(Date.now() / 1000)">
												<BaseUiCountdown :end="cart?.indicators?.cart_link?.datetime_expires" v-slot="{days, hours, minutes, seconds, ended}">
													<div class="w-discount-counter" v-if="!ended">
														Popust vrijedi još: 
														<span>
															<template v-if="days && days > 1">{{ days }}d</template>
															{{ hours }}h
															{{ minutes }}m
															{{ seconds }}s
														</span>
													</div>
												</BaseUiCountdown>
											</template>

											<WebshopLoyaltyNew />

											<div class="w-table" id="items_shoppingcart">
												<WebshopCartItem v-for="item in parcels[0].items" :data="item" :key="item.shopping_cart_code" />
											</div>

											<WebshopPriorityOrder />

											<WebshopFreeDeliveryList v-if="cart" :toFree="toFree" :cart="cart" />
										</div>
										<div class="w-col2">
											<div class="w-col2-all-cnt">
												<div class="w-col2-1">
													<WebshopCouponForm mode="webshop" />

													<BaseCmsLabel code="cart_total_title" class="w-totals-title" tag="div" />
													<WebshopTotal />

													<BaseWebshopCartErrors v-slot="{errors, warnings}">
														<NuxtLink @click="onFinishShopping" v-if="urls.webshop_customer && !errors && !warnings" :to="urls.webshop_customer" class="btn btn-primary btn-large w-btn-finish cart-finish-shopping"><BaseCmsLabel code="finish_shopping" tag="span" /></NuxtLink>
													</BaseWebshopCartErrors>
												</div>
												<div class="w-col2-2">
													<div class="sc-right-total-missing">
														<WebshopFreeDeliveryProgressBar :toFree="toFree" />
													</div>


													<div class="webshop-method-payment">
														<BaseUiSwiper class="w-benefits" :options="sliderOptions">
															<BaseUiSwiperSlide class="w-benefit w-benefit-1">
																<BaseCmsLabel code="w_benefit_delivery" tag="div" />
															</BaseUiSwiperSlide>
															<BaseUiSwiperSlide class="w-benefit w-benefit-2">
																<BaseCmsLabel code="w_benefit_payment" tag="div" />
															</BaseUiSwiperSlide>
															<BaseUiSwiperSlide class="w-benefit w-benefit-3">
																<BaseCmsLabel code="w_benefit_return" tag="div" />
															</BaseUiSwiperSlide>
														</BaseUiSwiper>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</template>

							<BaseCmsLabel v-else code="empty_shopping_cart" class="empty-cart" tag="div" />
						</div>
					</div>
				</BaseWebshopFreeShipping>

				<div class="w-mobile-fixed" v-if="parcels[0]?.items?.length">
					<BaseWebshopCartErrors v-slot="{errors, warnings}">
						<NuxtLink @click="onFinishShopping" v-if="urls.webshop_customer && !errors && !warnings" :to="urls.webshop_customer" class="btn btn-green w-finish-shopping-fixed"><BaseCmsLabel code="finish_shopping" /></NuxtLink>
					</BaseWebshopCartErrors>
				</div>
			</BaseWebshopCart>
			<template #fallback>
				<BaseThemeUiLoading />
			</template>
		</ClientOnly>
	</BaseCmsPage>
</template>

<script setup>
	const {prependTo, onMediaQuery} = useDom();
	onMediaQuery({
		query: '(max-width: 980px)',
		enter: () => {
			prependTo('.free-delivery-widget', '.w-col2');
		}
	});

	const sliderOptions = {
		slidesPerView: 1,
		slidesPerGroup: 1,
		speed: 500,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: true
		},
		navigation: {
			enabled: false,
		},
		breakpoints: {
			760: {
				enabled: false,
			}
		}
	}
</script>

<style lang="less" scoped>
	.cart-layout-page{
		.newsletter-loyalty{display: none;}
	}
	.w-title{
		text-align: left; padding-top: 0;
		@media (max-width: @m){font-size: 24px; line-height: 32px; font-weight: bold;}
	}
	.w-counter{
		margin-left: 10px; font-size: 25px; color: var(--primaryColor); font-weight: 300; display: none;
		&.active{display: inline;}
		@media (max-width: @t){font-size: 22px;}
		@media (max-width: @m){font-size: 18px; margin-left: 6px;}
	}

	.cart-layout{
		padding: 30px 0 100px 0;
		@media (max-width: @t){padding: 25px 0 60px;}
		@media (max-width: @tp){padding: 23px 0 50px;}
		@media (max-width: @m){
			padding: 0 0 40px; border-bottom: 1px solid var(--borderColor);
			.wider-wrapper{margin: 0;}
		}
	}
	#view_cart{width: 100%;}
	.w-cols{
		display: flex;
		@media (max-width: @tp){flex-wrap: wrap;}
	}
	.w-col1{
		width: 920px; flex-grow: 1; margin-right: 80px;
		@media (max-width: @l){width: 830px; margin-right: 45px;}
		@media (max-width: @t){width: auto; flex-grow: 1; flex-shrink: 1; min-width: 530px; margin-right: 35px;}
		@media (max-width: @tp){min-width: unset; margin-right: 0; width: 100%; flex-shrink: unset;}
	}
	.w-col2{
		width: 400px; flex-shrink: 0;
		@media (max-width: @l){width: 370px; flex-shrink: 0;}
		@media (max-width: @t){flex-shrink: 0; width: 300px; max-width: 300px;}
		@media (max-width: @tp){min-width: unset; max-width: unset; width: 100%; display: flex; padding-top: 0; flex-wrap: wrap; flex-flow: column;}
		@media (max-width: @m){padding: 0 15px;}
	}
	
	//COL1
	//------DISCOUNT COUNTER
	.w-discount-counter{
		padding: 3px 0 15px; font-weight: 300; border-bottom: 1px solid var(--borderColor); color: var(--primaryColor);
		@media (max-width: @m){padding: 14px 15px 10px; font-size: 16px;}
		span{font-weight: bold;}
	}

	//COL2
	.w-col2-all-cnt{
		@media (max-width: @tp){width: 100%; display: flex; padding-top: 30px; flex-flow: row-reverse;}
		@media (max-width: @m){padding-top: 25px; flex-flow: column;}
	}
	.w-col2-1{
		@media (max-width: @tp){width: 50%; flex-grow: 1;}
		@media (max-width: @m){width: 100%;}
	}
	.w-col2-2{
		@media (max-width: @tp){padding: 0 30px 0 0;  flex-shrink: 0; width: 50%; min-width: 325px;}
		@media (max-width: @m){padding-top: 15px; width: 100%; padding-top: 0; padding-right: 0; min-width: unset;}
	}
	.w-totals-title{
		font-size: 30px; line-height: 40px; color: var(--textColor); padding-bottom: 8px; padding-top: 20px; font-weight: 300;
		@media (max-width: @t){font-size: 26px; line-height: 30px; padding-top: 18px; padding-bottom: 8px;}
		@media (max-width: @m){font-size: 20px; line-height: 26px; font-weight: bold;}
	}
	.w-btn-finish{
		background: var(--primaryColor); width: 100%; margin: 0; margin-top: 22px; font-size: 18px; min-height: 60px; line-height: 60px;
		@media(min-width: @h){
			&:hover{background: #4D256F; color: white;}
		}
		@media (max-width: @t){width: 100%; min-width: 100%; min-height: 50px; height: 50px; margin-bottom: 0; margin-right: 0; margin-top: 13px; font-size: 16px; line-height: 22px;}
		@media (max-width: @m){
			margin: 12px 0; min-height: 50px; height: 50px; font-size: 16px; line-height: 20px; background: var(--lGreen);
			&:before{display: none;}
		}
	}
	.sc-right-total-missing{
		margin-top: 43px;
		@media (max-width: @tp){margin: 0 auto; width: auto;}
	}
	.w-benefits{
		display: flex; flex-flow: column; margin-top: 50px;
		@media (min-width: @m){
			:deep(.swiper){margin: unset;}
			.w-benefit{width: 100%!important; opacity: 1!important; transform: unset!important;}
			:deep(.swiper-wrapper){display: flex; flex-flow: column;}
		}
		@media (max-width: @l){margin-top: 45px;}
		@media (max-width: @m){
			margin-top: 25px;
			:deep(.swiper){max-width: 100%;}
		}
	}
	.w-benefit{padding-left: 80px; position: relative; margin-bottom: 35px; font-size: 16px; line-height: 21px; font-weight: 300;
		:deep(span){display: block; color: var(--primaryColor); font-weight: 500; font-size: 22px !important; line-height: 26px !important;}
		&:last-child{margin-bottom: 0;}
		&:before{.pseudo(57px,36px); left: 0; top: 6px; color: var(--primaryColor); .icon-delivery; font: 36px/36px var(--fonti);}
		@media (max-width: @l){margin-bottom: 30px;}
		@media (max-width: @t){
			margin-bottom: 20px; padding-left: 63px; font-size: 14px; line-height: 20px;
			&:before{width: 48px; height: 30px; left: 0; top: 4px; font: 30px/30px var(--fonti);}
			:deep(span){font-size: 18px !important; line-height: 22px !important;}
		}
		@media (max-width: @m){
			margin-bottom: 13px; padding-left: 52px; font-size: 13px; line-height: 17px;
			&:before{width: 38px; height: 24px; left: 0; top: 0; font: 24px/24px var(--fonti);}
			:deep(span){font-size: 16px !important; line-height: 20px !important; margin-top: 5px;}
		}
	}
	.w-benefit-2:before{
		.pseudo(47px,47px); font:47px/47px var(--fonti); .icon-cards; top: 0;
		@media (max-width: @t){width: 41px; height: 41px; font: 41px/41px var(--fonti); top: 0;}
		@media (max-width: @m){font: 34px/34px var(--fonti); width: 34px; height: 34px; top: 0;}
	}
	.w-benefit-3:before{
		.pseudo(47px,47px); font:47px/47px var(--fonti); .icon-return; top: 0;
		@media (max-width: @t){width: 46px; height: 43px; font: 43px/43px var(--fonti); top: -1px;}
		@media (max-width: @m){font: 32px/32px var(--fonti); width: 32px; height: 32px; top: 0;}
	}

	.w-mobile-fixed{
		display: none; position: fixed; bottom: 0; left: 0; right: 0; background: var(--white); padding: 12px 16px; align-items: center; justify-content: space-between; z-index: 999999;
		.btn{margin-bottom: 0; height: 50px; font-size: 16px; font-weight: bold;}
		@media (max-width: @m){display: flex;}
	}

	//Empty
	.empty-cart{
		padding: 60px 0 0 0; font-size: 20px; line-height: 30px;
		:deep(a){text-decoration: underline !important; color: var(--textColor);}
		@media (max-width: @tp){padding: 35px 0 0;}
		@media (max-width: @m){padding: 20px 15px 0; font-size: 18px; line-height: 26px;}
	}
</style>

<style lang="less">
	.cart-layout-page{
		.intro-container-inner{
			padding: 106px 350px 25px 0;
			@media (max-width: @t){padding: 65px 0 20px 0;}
			@media (max-width: @tp){padding: 43px 0 17px;}

		}
		@media (max-width: @m){
			.intro-container{
				min-height: 88px;
				.wider-wrapper{min-height: 88px;}
			}
		}
	}
</style>
